import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=4c18c9fe&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=4c18c9fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18c9fe",
  null
  
)

export default component.exports